import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LibPageHeaderComponent, LibWarrantyPolicyComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { IPageHeaderEntity, ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';

@Component({
  selector: 'app-life-long-warranty-policy',
  standalone: true,
  imports: [LibPageHeaderComponent, LibWarrantyPolicyComponent],
  templateUrl: './life-long-warranty-policy.component.html',
  styleUrl: './life-long-warranty-policy.component.scss',
})
export class LifeLongWarrantyPolicyComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'นโยบายการรับประกัน ตลอดอายุการใช้งาน',
    pageSubTitle: '(Life Long Warranty Policy)',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'นโยบายการรับประกัน ตลอดอายุการใช้งาน (Life Long Warranty Policy)',
        partName: '/life-long-warranty-policy',
      },
    ],
  });

  innerContent = `  
<div>
<img class="ml-5" src="../../../../assets/images/img-compensation-value.webp" alt="รูปภาพการคำนวณมูลค่าการชดเชย" title="รูปภาพการคำนวณมูลค่าการชดเชย" loading="lazy"/>
</div>
 <div>
 <p> การชดเชยจะกระทำโดยการขายยางใหม่ให้กับร้านค้าในราคาดังนี้</p>
 <p class="ml-10"> &nbsp; ราคายางใหม่สำหรับการชดเชย = ราคายางใหม่ (2) - มูลค่าการชดเชย</p>
 </div>
  <div class="flex">
      <p>หมายเหตุ :</p>
      <p>
        (1) ราคายาง คือ ราคาขายที่บริษัทฯขายยางที่ขอการรับประกันให้กับร้านค้านั้นๆ
        <br />
        (2) ราคายางใหม่ คือ ราคาในใบราคา (Price List) ของบริษัทฯที่ไม่รวมรายการส่งเสริมการขาย
      </p>
  </div>`;

  warrantyPolicyObj: ITermsAndPolicyEntity[] = [
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะรับประกันคุณภาพผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อ TOYO และ TOYO TIRES เฉพาะที่บริษัทฯนำเข้ามาจากต่างประเทศ ตามข้อกำหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการรับประกันคุณภาพเท่านั้น โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการถอดใส่ ค่าสูญเสียเวลา ค่าสูญเสียอันเนื่องจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่กฎหมายอนุญาต',
    },
    {
      title:
        'ผลิตภัณฑ์ยางรถยนต์ทุกเส้น จะได้รับการพิจารณาชดเชยต่อเมื่อได้รับการตรวจสอบว่าเป็นที่แน่ชัดว่ายางชำรุดดังกล่าวมีสาเหตุจากผู้ผลิต เช่น เกิดจากข้อบกพร่องในการออกแบบ กรรมวิธีการผลิต และ/หรือวัสดุที่ใช้ในการผลิต เป็นต้น',
    },
    {
      title:
        'การประเมินความชำรุดเสียหายของยางรถยนต์ว่าเกิดขึ้นเนื่องจากผู้ใช้หรือผู้ผลิต การตัดสินขั้นสุดท้ายจะกระทำโดยบุคคลที่ได้รับการแต่งตั้งจาก Toyo Tire Corporation',
    },
    {
      title: 'การประเมินมูลค่าการชดเชย จะคำนวณจากระดับความลึกของร่องดอกยางที่เหลืออยู่ ซึ่งสามารถคำนวณได้ดังนี้',
      subtitle: [
        {
          contentHTML: this.innerContent,
        },
      ],
    },
    {
      title: 'ยางชำรุดที่ได้รับการพิจารณาให้ชดเชย ให้ตกเป็นกรรมสิทธิ์ของ บริษัท อ.สยาม คอมเมอร์เชียล จำกัด',
    },
    {
      title: 'ระยะเวลาการรับประกันคุณภาพผลิตภัณฑ์ฯ : ตลอดอายุการใช้งาน',
    },
    {
      title: 'ยางรถยนต์ที่มีลักษณะดังต่อไปนี้ จะไม่ได้รับการพิจารณาชดเชยและให้ถือว่าสิ้นสุดการรับประกัน ได้แก่',
      subtitle: [
        {
          headers:
            'ยางชำรุดที่เกิดจากการถูกของแหลมคมบาดและ/หรือตำ เช่น ตะปู แผ่นเหล็ก เศษแก้ว หรือยางชำรุดที่เกิดจากการกระแทกกับก้อนหิน ขอบถนน ขอบหลุม หรือวัตถุอื่นๆ',
        },
        {
          headers:
            'ยางชำรุดที่เกิดจากการใช้ลมยางไม่ถูกต้อง หรือใช้กระทะล้อไม่ถูกต้อง หรือเกิดจากการใช้งานในขณะที่ไม่มีแรงดันลมยาง',
        },
        {
          headers:
            'ยางสึกหรอผิดปกติ เนื่องจากการใช้แรงดันลมยางไม่ถูกต้อง ไม่มีการสลับตำแหน่งยาง การใช้กระทะล้อไม่ถูกต้อง ความบกพร่องของช่วงล่าง ศูนย์ล้อ โช้คอัพ ระบบเบรค รวมถึงการไม่สมดุลของล้อหรือความบกพร่องของชิ้นส่วนอื่นๆของรถยนต์',
        },
        {
          headers: 'ยางชำรุดเนื่องจาก การใส่การถอดหรือการประกอบยางกับกระทะล้อไม่ถูกต้อง',
        },
        {
          headers: 'ยางที่เกิดปัญหาเต้นสั่น ภายหลังจากดอกยางสึกหรอไปแล้วมากกว่า 10%',
        },
        {
          headers: 'ยางที่ไม่ได้ซื้อขายผ่านผู้จัดจำหน่ายอย่างเป็นทางการจาก Toyo Tire Corporation',
        },
        {
          headers: 'ยางที่ถูกนำไปใช้ ไม่ถูกต้องตามข้อกำหนด หรือใช้ในการแข่งขัน หรือรถที่ใช้งานพิเศษ',
        },
        {
          headers: 'ยางที่ถูกใช้งานจนความลึกของร่องดอกยางหลัก (Principal grooves) เหลือน้อยกว่า 2.0 มิลลิเมตร',
        },
        {
          headers: 'ยางที่มีการชำรุดเสียหายสืบเนื่องมาจากการปะ - ซ่อม',
        },
        {
          headers:
            'ยางที่เกิดอาการเสียงยางผิดปกติ อันเนื่องมาจากการสึกหรอผิดปกติของดอกยางหรือเสียงยางอันเนื่องมาจากความไม่พึงพอใจของลูกค้า',
        },
      ],
    },
    {
      title:
        'ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางจากร้านค้ามายังบริษัทฯเพื่อขอให้บริษัทฯพิจารณาชดเชย โดยบริษัทฯจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใดๆในระหว่างการขนส่ง',
    },
    {
      title: 'ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางที่ไม่ได้รับการชดเชยกลับคืนให้ลูกค้า',
    },
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ขอสงวนสิทธิ์ในการยกเลิกและ/หรือแก้ไขเปลี่ยนแปลงนโยบายการรับประกันคุณภาพฯนี้ ทั้งหมดหรือส่วนหนึ่งส่วนใด เพื่อความเหมาะสม โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า',
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }

  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }
  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'นโยบายการรับประกัน ตลอดอายุการใช้งาน | TOYO TIRES Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย เพื่อให้คุณใช้งานเว็บไซต์และบริการของ TOYO TIRES ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | TOYO TIRES Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo-toyo_result-20250819114158.webp',
    });
  }
}
